module.exports = __webpack_public_path__ + "img/image_03.4a41b15a.jpg";